import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button } from 'antd';

import { actions } from "store";
import { Page, PageHeader } from 'components/layout';
import { MessageList, MessageForm } from 'components/blocks/message';


class MessageListScreen extends Component {
    showEditForm = (item = null) => {
        const { actions } = this.props;
        actions.messageShowEditForm({ show: true, object: item });
    };

    render() {
        const { history } = this.props;

        return (
            <Page>
                <PageHeader
                    title="Cообщения"
                    actions={[
                        <Button type="primary" className="" icon="plus" onClick={() => this.showEditForm()}>
                            Добавить сообщение
                        </Button>
                    ]}
                    history={history}
                    basePath={`/message`}
                    onTabChange={this.onTabChange}
                />

                <div className="page-content page-content-full">
                    <div className="page-block page-block-full">
                        <MessageList
                            basePath="/message"
                            history={history}
                        />
                    </div>
                </div>

                <MessageForm/>
            </Page>
        );
    }
}


function mapStateToProps(state) {
    return {
        message: state.message,
    };
}


function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, actions.message), dispatch),
        dispatch: dispatch
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(MessageListScreen);
